import { getUNESCOLabel, getUNESCOLabelSync } from '@/utils/unescoSubjects';

export const itemColumns = (deleteItemFn) => [
  { title: "ID", field: "_id", width: 70 },
  { title: "Label", field: "el_Label", width: 200 },
  { title: "Type", field: "el_Type", width: 150 },
  { title: "Main Question", field: "el_Text", width: 300 },
  { title: "ISCED", field: "metadata.ISCED", width: 150 },
  { 
    title: "Subject", 
    field: "metadata.subject",
    width: 200,
    formatter: function(cell) {
      const value = cell.getValue();
      if (!value) return '';
      
      // Créer un span temporaire avec la valeur originale
      const span = document.createElement('span');
      span.textContent = value;
      span.style.color = '#6c757d';
      span.style.fontStyle = 'italic';
      
      // Convertir de façon asynchrone et mettre à jour le contenu
      getUNESCOLabel(value).then(label => {
        span.textContent = label;
        span.style.color = '';
        span.style.fontStyle = '';
      }).catch(error => {
        console.error('Error converting UNESCO code to label:', error);
        span.textContent = value; // Garder la valeur originale en cas d'erreur
        span.style.color = '#dc3545';
      });
      
      return span;
    },
    sorter: function(a, b) {
      // Trier selon l'intitulé UNESCO au lieu du code
      const labelA = getUNESCOLabelSync(a) || a;
      const labelB = getUNESCOLabelSync(b) || b;
      
      return labelA.localeCompare(labelB, 'fr', { numeric: true, sensitivity: 'base' });
    }
  },
  { title: "Domaine", field: "metadata.domain", width: 150 },
  {
    title: "Mots-clés",
    field: "metadata.keywords",
    formatter: (cell) => (Array.isArray(cell.getValue()) ? cell.getValue().join(", ") : ""),
    width: 200,
  },
  {
    title: "Action",
    field: "action",
    width: 80,
    hozAlign: "center",
    formatter: (cell) => {
      const el_id = cell.getRow().getData()._id;
      return `<button class="delete-btn" data-id="${el_id}" title="Delete item">
        <i class="bi bi-trash3"></i>
      </button>`;
    },
    cellClick: (_, cell) => {
      const el_id = cell.getRow().getData()._id;
      if (confirm("Supprimer cet item ?")) {
        deleteItemFn(el_id); // ← appel direct à la fonction du parent
      }
    },
  },
];